import { MsalConfig } from '../msalConfig';
import {
	loadFromLocalStorage,
	loadFromLocalStorageOrSaveDefault,
	saveToLocalStorage,
} from '../libs/localStorageHelper';

const localeKey = 'omniportal.locale';
const licenseToggleKey = 'omniportal.licenseToggle';

export const isAuthMocked = process.env.REACT_APP_USE_MSAL_MOCK === 'true';

export interface Config {
	baseUrl?: string;
	dateFormatOptions: Intl.DateTimeFormatOptions;
	fallbackLocale: string;
	msal: MsalConfig;
	locale: string;
	licenseToggle: boolean;
}

const dateFormatOptions: Intl.DateTimeFormatOptions = {
	year: 'numeric',
	month: 'long',
	day: 'numeric',
};

export const defaultConfig: Config = {
	baseUrl: process.env.REACT_APP_BASE_URL,
	dateFormatOptions,
	get locale(): string {
		return loadFromLocalStorageOrSaveDefault(localeKey, 'en-US');
	},
	set locale(value: string) {
		saveToLocalStorage(localeKey, value);
	},
	get fallbackLocale(): string {
		return 'en-US';
	},
	msal: {
		clientId: process.env.REACT_APP_MSAL_CLIENT_ID || '',
		authority: process.env.REACT_APP_MSAL_AUTHORITY || '',
		redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI || window.location.origin,
		scopes: (process.env.REACT_APP_MSAL_SCOPES || '').split(',').filter(Boolean),
	},
	get licenseToggle(): boolean {
		return (
			(loadFromLocalStorage(licenseToggleKey) ||
				process.env.REACT_APP_LICENSE_TOGGLE ||
				'false') === 'true'
		);
	},
	set licenseToggle(value: boolean) {
		saveToLocalStorage(licenseToggleKey, value.toString());
	},
};

export const dynamicConfigUrl =
	'/config.json?' + new Date().getTime().toString();
